import { useStores } from 'src/contexts/stores';

export function useInstoreEnrollment(): any {
  const { InstoreEnrollment } = useStores();

  return InstoreEnrollment;
}
